import Cookies from 'js-cookie';

const getCookie = cookieName => Cookies.get(cookieName);
const removeCookie = (cookieName, cookieAttributes) => Cookies.remove(cookieName, cookieAttributes);
const setCookie = (cookieName, cookieValue, cookieAttributes) => Cookies.set(cookieName, cookieValue, cookieAttributes);

export { getCookie, removeCookie, setCookie };
//# sourceMappingURL=cookies.js.map
